module.exports = __webpack_public_path__ + "img/kapila-siriwardhana-leccturing-03-small.08acd454.jpg";